<template>
  <BaseAction>
    <div class="d-flex justify-center">
      <SecondaryButton @click.native="openDialog" textColor="#a63232">
        <v-icon>
          mdi-thumb-down-outline
        </v-icon>
        Reject Document
      </SecondaryButton>
      <RejectDocumentDialog v-if="isOpen" @close="closeDialog" />
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import RejectDocumentDialog from "@/views/offers/components/OfferDocument/dialogs/RejectDocumentDialog";

export default {
  name: "RejectOfferAction",
  components: {
    SecondaryButton,
    BaseAction,
    RejectDocumentDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
